export const enumTypePicker = {
  DATE: 'date',
  MONTH: 'month',
  RANGE: 'range',
  WEEK: 'week',
};
